import { useAntdTable } from 'ahooks'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { MosaicComponent, RelationsCreatorDropdown, getPointPermission } from '@/components'
import { CustomerTerminateFlowStatus } from '@/modules/customer/customer.schema'
import { DevlopStatus } from '@/modules/devlop/devlop.schema'
import { DisabledRelationStatus } from '@/modules/production-project/production-detail/production-summary'
import { Production, ProductionTerminateFlowStatus } from '@/modules/production-project/production.schema'
import { FetchType, PAGE_RESOURCE_POINTS_ENUM, PpRelation, Resource, ResourceType } from '@/schemas'

import { NormalResourceTable, deleteChildren } from './portfolio-table.component'

interface NormalResourceListProps {
  resource: Resource
  renderExtras?: any
  pageType: ResourceType
  defaultFilter?: number[]
}

export const NormalResourceList: React.FC<NormalResourceListProps> = ({
  resource,
  renderExtras,
  pageType,
  defaultFilter,
}) => {
  const { selfId, type } = resource
  const { canCreate, canDelete, canUpdate, canRead } = getPointPermission(
    PAGE_RESOURCE_POINTS_ENUM.概况_关联子集,
    resource.permissions
  )
  const { t } = useTranslation()
  const { tableProps, refresh } = useAntdTable<PpRelation[], any, PpRelation[]>(
    {
      url: '/api/relations/getPpRelations',
      params: {
        parentSelfId: selfId,
        rootTypes: [ResourceType.PROJECT, ResourceType.PORTFOLIO],
        childTypes: [ResourceType.PROJECT, ResourceType.PORTFOLIO],
        fetchType: FetchType.fetchChild,
      },
    },
    {
      refreshDeps: [selfId],
      manual: !canRead,
      formatResult: (data) => ({ list: deleteChildren(data), total: 0 }),
    }
  )

  const productionSpecialPermission =
    resource.type === ResourceType.PRODUCTION
      ? !DisabledRelationStatus.includes((resource as Production).flowStatus)
      : true

  let isArchivedResource = false
  switch (pageType) {
    case ResourceType.CUSTOMER: {
      isArchivedResource = CustomerTerminateFlowStatus.includes(resource['flowStatus'])
      break
    }
    case ResourceType.PRODUCTION: {
      isArchivedResource = ProductionTerminateFlowStatus.includes(resource['flowStatus'])
      break
    }
    case ResourceType.DEVLOP: {
      isArchivedResource = resource['status'] === DevlopStatus.已结项
      break
    }
  }

  return (
    <div className='space-y-24px'>
      {canCreate && productionSpecialPermission && !isArchivedResource && (
        <RelationsCreatorDropdown
          direction='down'
          rootSelfId={selfId}
          selfId={selfId}
          type={type}
          onSuccess={refresh}
          disabledSelfIds={(tableProps.dataSource || []).map((d) => d.selfId)}
        >
          <Button type='primary'>{t('add projects/portfolios')}</Button>
        </RelationsCreatorDropdown>
      )}
      {canRead ? (
        <>
          {/* @ts-ignore */}
          <NormalResourceTable
            selfId={selfId}
            type={type}
            pageType={pageType}
            name={document.title}
            onSuccess={refresh}
            canDelete={canDelete}
            canUpdate={canUpdate}
            renderExtras={renderExtras}
            defaultFilter={defaultFilter}
            {...tableProps}
          />
        </>
      ) : (
        <MosaicComponent />
      )}
    </div>
  )
}
